import React from 'react';

/**
 * Returns the previous value of a variable
 * @param value
 * @returns
 */
const usePrevious = <T>(value: T) => {
    const ref = React.useRef<T | undefined>(undefined);

    React.useEffect(() => {
        ref.current = value;
    });

    return ref.current;
};

export default usePrevious;
